export const VIEWS = {
  LOGIN: 'LOGIN',
  SELECT_PLATFORM: 'SELECT_PLATFORM',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  RESET_PASSWORD: 'RESET_PASSWORD',
  FORGOT_PASSWORD_CONFIRMATION: 'FORGOT_PASSWORD_CONFIRMATION',
  RESET_PASSWORD_CONFIRMATION: 'RESET_PASSWORD_CONFIRMATION',
};
